var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("menu.role_list")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "system-role-list page-container" },
      [
        _c(
          "div",
          { staticClass: "filter-container" },
          [
            _c("div", { staticClass: "filter-container-tag" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
            ]),
            _c("el-input", {
              staticClass: "search-frame",
              attrs: { placeholder: _vm.$t("system.role_name"), clearable: "" },
              model: {
                value: _vm.search.role_name,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "role_name", $$v)
                },
                expression: "search.role_name",
              },
            }),
            _c(
              "el-button",
              {
                staticClass: "search-btn",
                attrs: { type: "primary", icon: "el-icon-search" },
                on: { click: _vm.handleFilter },
              },
              [_vm._v(_vm._s(_vm.$t("components.search")))]
            ),
            _c(
              "el-button",
              {
                staticClass: "filter-btn-add mb10 ",
                attrs: { type: "primary" },
                on: { click: _vm.showAddRoleModal },
              },
              [
                _c("i", {
                  staticClass: "el-icon-plus",
                  staticStyle: { "font-weight": "600" },
                }),
                _vm._v(_vm._s(_vm.$t("system.add_role"))),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "tableContainer" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  stripe: "",
                  fit: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "ID",
                    align: "center",
                    type: "index",
                    width: "50",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("system.role_name"), align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.role_name) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: _vm.$t("system.remark"), align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.remark) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.operator"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.mch_user
                                  ? scope.row.mch_user.username
                                  : "System"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.create_time"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.create_time) + " "),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("components.operation"),
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                plain: "",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showUpdateRoleAuthModal(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("system.update_role")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("add-role-modal", {
          ref: "addRoleAuthRef",
          attrs: { "menu-list": _vm.menu_list },
          on: { updateRoleList: _vm.handleFilter },
        }),
        _c("update-role-auth-modal", {
          ref: "updateRoleAuthRef",
          attrs: { "menu-list": _vm.menu_list },
          on: { updateRoleList: _vm.handleFilter },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }